import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import PhoneIcon from "@mui/icons-material/PhoneOutlined";
import { assets } from "@/lib/assets";
import { container } from "@/lib/ui";

const navItems = [
  { to: "/", key: "nav.home" },
  { to: "/products", key: "nav.products" },
  { to: "/about", key: "nav.about" },
  { to: "/contact", key: "nav.contact" },
] as const;

const beian = "沪ICP备2026028646号";

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[#070b10] text-[#9aa4ad]">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand/50 to-transparent" />
      <div className="pointer-events-none absolute -top-28 left-1/3 h-72 w-72 -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(1,120,254,0.14),transparent_60%)] blur-3xl" />

      <div className={`${container} relative py-16`}>
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1.3fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <img src={assets.logo} alt="赋维世" className="h-9 w-9" />
              <span className="flex flex-col leading-none">
                <span className="font-display text-xl font-bold tracking-wide text-[#f3f6f8]">
                  赋维世
                </span>
                <span className="text-[10px] font-medium uppercase tracking-[0.25em] text-white/40">
                  Furtherverse
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-[#f3f6f8]">{t("footer.nav")}</h4>
            <ul className="mt-4 space-y-3">
              {navItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="inline-block text-sm transition-all duration-300 hover:translate-x-1 hover:text-brand-cyan"
                  >
                    {t(item.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-[#f3f6f8]">{t("footer.contact")}</h4>
            <ul className="mt-4 space-y-4 text-sm">
              <li>
                <a
                  href="mailto:wangchenxi@furtherverse.com"
                  className="group flex items-center gap-3 transition-colors hover:text-brand-cyan"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-brand/25 to-brand-cyan/10 text-brand ring-1 ring-inset ring-brand/20 transition-transform duration-300 group-hover:scale-110">
                    <EmailIcon style={{ fontSize: 18 }} />
                  </span>
                  wangchenxi@furtherverse.com
                </a>
              </li>
              <li>
                <a
                  href="tel:19121572744"
                  className="group flex items-center gap-3 transition-colors hover:text-brand-cyan"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-brand/25 to-brand-cyan/10 text-brand ring-1 ring-inset ring-brand/20 transition-transform duration-300 group-hover:scale-110">
                    <PhoneIcon style={{ fontSize: 18 }} />
                  </span>
                  191 2157 2744（王晨曦）
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-[#5b6670] md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} 上海赋维世科技有限公司 · Furtherverse</p>
          {beian && (
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:text-brand-cyan"
            >
              {beian}
            </a>
          )}
        </div>
      </div>
    </footer>
  );
}
